import config from "./config";
import apiService from "./apiService";
export default {
  async getInvestmentInformation(clientId, entitytypeid) {
    let investmentApiUrl = `${config.investmentApiUrl}/${clientId}/?entityTypeId=${entitytypeid}`;
    return apiService.get(investmentApiUrl);
  },
  async saveInvestmentInformation(investmentModel, projectionModel) {
    let payload = {
      investmentDTO: investmentModel,
      projectionResult: projectionModel,
    };
    let saveliablityApiUrl = `${config.saveInvestmentApiUrl}`;
    return apiService.post(saveliablityApiUrl, payload);
  },
  async saveAsInvestmentInformation(investmentModel, projectionModel) {
    let payload = {
      investmentDTO: investmentModel,
      projectionResult: projectionModel,
    };
    let saveliablityApiUrl = `${config.saveAsInvestmentApiUrl}`;
    return apiService.post(saveliablityApiUrl, payload);
  },
  async createCopyOfInvestment(apiModel) {
    let apiUrl = `${config.copyInvestmentApiUrl}`;
    return apiService.post(apiUrl, apiModel);
  },

  async deleteInvestment(investmentGuid,encClientId) {
    let apiUrl = `${config.investmentApiUrl}/${investmentGuid}/${encClientId}`;
    return apiService.delete(apiUrl);
  },
  async updateInvestment(investment) {
    let apiUrl = `${config.investmentApiUrl}`;
    return apiService.put(apiUrl, investment);
  },
};
